import { ESimCardModule } from '@reolink-cloud/interface';
import { getSimCard } from '@/api/sim';
import { SimManager, uidHandler } from '@/lib';

export const redirectIfSimHasSubscription = async (
    iccid: string,
    replace: ( location: { path: string; query: { ymh: string; }; }) => Promise<unknown>
): Promise<boolean> => {

    if ( !iccid ) {

        return false;

    }

    try {

        const rawSimData = await getSimCard({
            iccid,
            includes: [ESimCardModule.CLOUD_SERVICES, ESimCardModule.LAST_USED_DEVICE, ESimCardModule.SIM_CARD],
            checkActionConfig: true,
        });
        const simManager = new SimManager( rawSimData, rawSimData.services );
        if ( !simManager.currentSubscriptionWithoutStatus ) {

            return false;

        }

        await replace({
            path: '/user/my-sim',
            query: {
                ymh: uidHandler.encrypt( iccid )
            }
        });
        return true;

    } catch ( e ) {

        console.error( e );
        return false;

    }

};
